import { TSetPageType } from '../../actions/page';

export const PAGE_SET_PAGE_TYPE: TSetPageType = 'page/setPage';
